import(/* webpackMode: "eager" */ "/home/runner/work/corporate-catalog-frontend/corporate-catalog-frontend/apps/lp/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/corporate-catalog-frontend/corporate-catalog-frontend/node_modules/.pnpm/next@15.5.9_@opentelemetry+api@1.9.0_react-dom@19.1.2_react@19.1.2__react@19.1.2/node_modules/next/dist/client/script.js");
